import { render } from "./SceletonMicroNews.vue?vue&type=template&id=571040a2&scoped=true"
import script from "./SceletonMicroNews.vue?vue&type=script&lang=js"
export * from "./SceletonMicroNews.vue?vue&type=script&lang=js"

import "./SceletonMicroNews.vue?vue&type=style&index=0&id=571040a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571040a2"]])

export default __exports__